import $ from "jquery";
import { Loader } from "@googlemaps/js-api-loader";
import MarkerClusterer from "@googlemaps/markerclustererplus";
let baseUrl;

let listEl = $(".specialist-list");
let mapInitEl = $(".specialist-mapinit");

let isMapInitialized = false;
const center = { lat: 49.8175, lng: 15.473 };
let map;
let autocomplete;
let geocoder;
let location = false;
let markers = [];
let infowindows = [];
let currentMarkers = [];
let specialistMarkersInfo = [];
let locationMarker = false;
let markerCluster = null;

let searchedByName = false;

let filter = {
  location: false,
  service: false,
  search: '',
  page: 1,
  noLimit: false
};

const loader = new Loader({
  apiKey: "AIzaSyDcrKy0_Xl4vw4R0gBMxfAxmQBH6XdtoEc",
  version: "weekly",
  libraries: ["places", "geometry"],
});

$(function () {
  mapInitEl.on("click", function () {
    initMap();
  });

  listEl.each(function () {
    specialistList($(this));
  });
});

const initMap = () => {

  if (!isMapInitialized) {
    isMapInitialized = true;

    $(".specialist-list__top_mapImage").hide();
    $(".specialist-list__top_mapCover").hide();
    $(".specialist-list__top_mapText").hide();
    $(".specialist-list__top_mapWrapper").css('position', 'initial');
    $(".specialist-list__top_map").show();
    
    if (listEl.length > 0) {
      baseUrl = window.location.href.split("specialiste")[0];
      loader.load().then(() => {
        map = new google.maps.Map(listEl.find(".specialist-list__top_map")[0], {
          zoom: 7,
          center: center,
        });
        autocomplete = new google.maps.places.Autocomplete(
          listEl.find("#specialist-list__top_input_text")[0],
          {
            fields: ["geometry", "name"],
            componentRestrictions: { country: "cz" },
            origin: center,
          }
        );
        geocoder = new google.maps.Geocoder();
        console.log(geocoder);
        listEl.each(function () {
          specialistList($(this));
        });
      });
    }
  }
  
}

const specialistList = (listEl) => {  
  if (isMapInitialized) {    

    bindSpecialistMarkers(listEl, filter);
    reRenderList(listEl, filter);
  } else {
    bindSpecialistButtons(listEl, filter);
  }
};

const reRenderList = async (element, filter, update = true) => {  
  const data = await getSpecialists(filter);  
  
  if (update) {
    await updateMap(data.specialists, data.countToShow);
  }
  
  element.find(".specialist-list__content").html(data.html);
  if (location) {
    const from = new google.maps.LatLng(
      location.geometry.location.lat(),
      location.geometry.location.lng()
    );
    $.each(element.find(".specialist-list__middle_row"), function (key, el) {
      const row = $(el);
      if (row.hasClass("head")) return;
      const lat = parseFloat(
        $(row.find(".specialist-list__middle_rowLocation_lat")[0]).attr("value")
      );
      const lng = parseFloat(
        $(row.find(".specialist-list__middle_rowLocation_lng")[0]).attr("value")
      );
      const to = new google.maps.LatLng(lat, lng);
      let dist = google.maps.geometry.spherical.computeDistanceBetween(
        from,
        to
      );
      dist = (dist / 1000).toFixed(dist < 20000 ? 1 : 0);
      $(row.find(".specialist-list__middle_rowName")[0]).append(
        "<div>Vzdálenost " + dist + " km</div>"
      );
    });
  }
};

const bindSpecialistButtons = (element, filter) => {
  element.on("click", ".specialist-list__top_buttonSearch", function () {
    initMap();
    filter.page = 1;
    filter.service = $("select[name='specialist-list__services']").val();
    filter.search = $("#specialist-list__top_input_search").val();
    filter.noLimit = false;
    filter.location = location
      ? {
          lat: location.geometry.location.lat(),
          lng: location.geometry.location.lng(),
        }
      : false;
    reRenderList(element, filter);
  });

  element.on("click", ".specialist-list__top_buttonReset", function () {
    filter.page = 1;
    filter.location = false;
    filter.service = false;
  
    location = false;
    element.find("#specialist-list__top_input_text").val("");
    
    element.find("select[name=specialist-list__services]").val("");
    reRenderList(element, filter);
  });

  element.on("click", ".specialist-list__search_buttonSearch", function () {
    initMap();
    filter.page = 1;
    filter.service = $("select[name='specialist-list__services']").val();
    filter.search = $("#specialist-list__top_input_search").val();

    filter.location = location
      ? {
          lat: location.geometry.location.lat(),
          lng: location.geometry.location.lng(),
        }
      : false;
    reRenderList(element, filter);

    searchedByName = true;
  });

  element.on("click", ".specialist-list__search_buttonReset", function () {
    if (searchedByName) {
      filter.page = 1;      
      filter.search = '';
      
      element.find('#specialist-list__top_input_search').val('');
      
      reRenderList(element, filter);

      searchedByName = false;
    }
  });

  element.on("click", ".specialist-list__middle_buttonShowAll", function () {
    filter.page = 1;
    filter.noLimit = true;
    
    reRenderList(element, filter, false);
  });

  element.on("click", ".specialist-list__top_buttonLocation", function () {
    initMap();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleUserLocation);
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  });

  element.on("click", ".pagination__item", function () {
    filter.page = $(this).data("page");
    reRenderList(element, filter, false);
    
    $('html, body')
        .stop()
        .animate(
            {
                scrollTop: $('.specialist-list__middle').offset().top - 60,
            },
            500
        );
  
  });

  element.on("keydown", "#specialist-list__top_input_text", function () {
    if (this.value.length > 0) {
      initMap();
    }
  });

  element.on("change", "#specialist-list__top_input_text", function () {
    
    location = false;
    if ($(this).val().trim()) {
      $(this).css("border-color", "red");
    } else {
      $(this).css("border-color", "#d6d6d6");
    }
  });
}

const bindSpecialistMarkers = (element, filter) => {
  $("form").submit(function (e) {
    // e.preventDefault();
  });

  element.on("mouseenter", ".specialist-list__middle_row", function () {
    const row = $(this);
    if (row.hasClass("head")) return;
    const id = parseInt(row.attr("value"));
    if (typeof specialistMarkersInfo[id] !== "undefined") {
      $.each(specialistMarkersInfo[id], function (key, latLng) {
        currentMarkers.push(
          new google.maps.Marker({
            map,
            position: latLng,
            icon: {
              url: "https://maps.google.com/mapfiles/ms/icons/purple-dot.png",
            },
          })
        );
      });
    }
  });

  element.on("mouseleave", ".specialist-list__middle_row", function () {
    $.each(currentMarkers, (key, marker) => {
      marker.setMap(null);
    });
    currentMarkers = [];
  });

  google.maps.event.addListener(autocomplete, "place_changed", function () {
    const place = autocomplete.getPlace();
    location = typeof place !== "undefined" ? place : false;
    setLocationMarker(location.name);
    element
      .find("#specialist-list__top_input_text")
      .css("border-color", "#d6d6d6");
  });
};

const getSpecialists = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + `/wp-json/nzu/v1/specialistList/html`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const handleUserLocation = async (locationResult) => {
  const latLng = {
    lat: locationResult.coords.latitude,
    lng: locationResult.coords.longitude,
  };
  geocoder.geocode({ location: latLng }, (results, status) => {
    if (status === "OK") {
      location = results[0];
      $("#specialist-list__top_input_text").val(location.formatted_address);
      setLocationMarker(location.formatted_address);
    }
  });
};

const setLocationMarker = (text) => {
  if (locationMarker) {
    locationMarker.setMap(null);
    locationMarker = false;
  }
  if (location) {
    const contentString =
      '<div class="marker-popup">' +
      '<h4 class="marker-popup__header">Zadaná adresa</h4>' +
      '<div class="marker-popup__text">' +
      '<p class="marker-popup__text__location">' +
      text +
      "</p>" +
      "</div>" +
      "</div>";
    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });
    const latLng = {
      lat: location.geometry.location.lat(),
      lng: location.geometry.location.lng(),
    };
    const marker = new google.maps.Marker({
      map,
      position: latLng,
      clickable: true,
      icon: {
        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
      },
    });
    marker.setAnimation(google.maps.Animation.BOUNCE);
    setTimeout(function () {
      marker.setAnimation(null);
    }, 1400);
    marker.addListener("click", () => {
      $.each(infowindows, (key, infowin) => {
        infowin.close();
      });
      infowindow.open(map, marker);
    });
    locationMarker = marker;
    map.setCenter(latLng);
    map.setZoom(11);
  }
};

const updateMap = async (data, countToShow) => {
  if (markerCluster) {
    markerCluster.clearMarkers();
  }

  specialistMarkersInfo = [];
  $.each(markers, (key, marker) => {
    marker.setMap(null);
  });
  $.each(infowindows, (key, infowin) => {
    infowin.close();
  });
  markers = [];
  $.each(data, function (key, specialist) {
    let title;
    if (specialist.type === "firma") {
      title = specialist.company_name;
    } else {
      title = [
        specialist.title1,
        specialist.first_name,
        specialist.last_name,
        specialist.title2,
      ].join(" ");
    }
    specialistMarkersInfo[specialist.id] = [];
    $.each(specialist.addresses, (key2, address) => {
      const address_text = [
        address.street,
        address.street_number + ",",
        address.city,
      ].join(" ");
      const contentString =
        '<div class="marker-popup">' +
        '<h4 class="marker-popup__header"><a href="' +
        baseUrl +
        "specialista/" +
        specialist.id +
        '" target="_blank">' +
        title +
        "</a></h4>" +
        '<div class="marker-popup__text">' +
        '<p class="marker-popup__text__location">' +
        address_text +
        "</p>" +
        (address.phone
          ? '<p class="marker-popup__text__phone">' + address.phone + "</p>"
          : "") +
        (address.email
          ? '<p class="marker-popup__text__email">' + address.email + "</p>"
          : "") +
        "</div>" +
        "</div>";
      const infowindow = new google.maps.InfoWindow({
        content: contentString,
      });
      const marker = new google.maps.Marker({
        map,
        position: { lat: address.lat, lng: address.lng },
        title: title,
        clickable: true,
        icon: {
          url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
        },
      });
      marker.addListener("click", () => {
        $.each(infowindows, (key, infowin) => {
          infowin.close();
        });
        infowindow.open(map, marker);
      });
      markers.push(marker);
      infowindows.push(infowindow);
      specialistMarkersInfo[specialist.id].push({
        lat: address.lat,
        lng: address.lng,
      });
    });
  });
  if (markers.length) {
    if (markers.length == 1){
      map.setCenter(markers[0].position);
      map.setZoom(12);
    } else {
      var bounds = new google.maps.LatLngBounds();
      let markersToShow = markers.slice(0, countToShow);
      
      $.each(markersToShow, (key, marker) => {
        bounds.extend(marker.position);
      });
      map.fitBounds(bounds, 5);
      markerCluster = new MarkerClusterer(map, markers, {
        minimumClusterSize: 5,
        imagePath:
          "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
      });
    }
  } else {
    if (map !== undefined) {
      map.setCenter(center);
      map.setZoom(7);
    }
  }
};
